import React, { useEffect } from "react";
import { markAfishaBootSuccess } from "../../../services/clientAlert";
import "./AfishaPage.scss";

export const AfishaAboutPage = () => {
  useEffect(() => {
    markAfishaBootSuccess();
  }, []);

  return (
    <div className="afisha__about">
      <h1 className="afisha__about-title">О проекте</h1>
      <p>
        Проект предназначен для удобного поиска городских мероприятий.
        Алгоритм находит события в телеграм-каналах города, вычленяет дату,
        даёт мероприятиям заголовок и формирует удобную афишу.
      </p>
      <p>
        Сейчас сервис работает для <strong>Краснодара</strong>. Афиша
        обновляется автоматически — новые события появляются по мере
        публикации в каналах.
      </p>
      <p>
        Возможны неточности: актуальные детали всегда уточняйте в
        первоисточнике — по ссылке на пост канала.
      </p>
      <p>
        По вопросам и предложениям пишите{" "}
        <a
          className="afisha__about-link"
          href="https://t.me/zahardjagaev"
          target="_blank"
          rel="noopener noreferrer"
        >
          @zahardjagaev
        </a>{" "}
        в Telegram.
      </p>
    </div>
  );
};
